module.exports = __webpack_public_path__ + "c262079ba38cf6ae3e551c8d6d27cec6.fbx";